import {Injectable, OnDestroy} from '@angular/core';
import {DatePipe} from '@angular/common';
import {DialogPosition, MatDialog, MatDialogRef, MatDialogConfig} from '@angular/material/dialog';
import {Apollo} from 'apollo-angular';
import {TranslateService} from '@ngx-translate/core';
import {Observable, Subscription} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {IndexedDBTableName, TableColumn} from '../shared/interfaces/table.interface';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService implements OnDestroy {

  subscription: Subscription = new Subscription();
  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private apollo: Apollo,
    private translate: TranslateService,
    private router: Router,
  ) {
  }

  encoder(data, loop = 2, key = 'secured'): string {
    let returnedData = btoa(data);
    const keyValue = btoa(key);
    returnedData = btoa(keyValue + returnedData);
    for (let i = 0; i < loop; i++) {
      returnedData = btoa(returnedData);
    }
    return returnedData;
  }

  decoder(data, loop = 2, key = 'secured') {
    let returnedData = data;

    for (let i = 0; i < loop; i++) {
      returnedData = atob(returnedData);
    }
    const keyValue = btoa(key);
    returnedData = atob(returnedData);

    return atob(returnedData.substr(keyValue.length));
  }

  switchLang(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  // demoList(arrayLength?: number) {
  //   return Array((arrayLength === null) ? 100 : arrayLength).fill(0).map((x, i) => ({ id: i, value: `${'Title ' + i}` }));
  // }

  openModal(data: any, component: any, width?: string, panelClass?: string[], position?: DialogPosition, height?: string) {
    const dialogConfig = new MatDialogConfig();
    const classes: string[] = [];
    if (panelClass?.length > 0) {
      classes.push(...panelClass);
    }
    const customClasses = classes?.length > 0 ? classes : ['custom-modal-dialog'];
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = width ? width : '60%';
    dialogConfig.data = data;
    dialogConfig.panelClass = customClasses;
    if (position != null) { dialogConfig.position = position; }
    if (height != null) { dialogConfig.height = height; }
    return this.dialog.open(component, dialogConfig);
  }

  reloadCurrentRoute(currentUrl) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    currentUrl = currentUrl === null ? this.router.url : currentUrl;
    this.router.navigate([currentUrl]);
  }

  isLicenceValid(expiryDate: string): boolean {
    const today = new DatePipe('en-Gb').transform(new Date(), 'yyyy-MM-dd');
    const expireDate = new DatePipe('en-Gb').transform(expiryDate, 'yyyy-MM-dd');
    return today <= expireDate;
  }

  generatePagination(current: number, lastPage: number) {
    // return  Array((totalPages === 1) ? 1 : totalPages).fill(0).map((x, i) => ({id: i}));
    const delta = 6;
    const range = [0];
    const rangeWithDots = [];
    let l;

    range.push(1);
    for (let i = current - delta; i <= current + delta; i++) {
      if (i < lastPage && i > 1) {
        range.push(i);
      }
    }
    range.push(lastPage);

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }
    return rangeWithDots;
  }


  getStartDate(){
    return new DatePipe('en-Gb').transform( new Date().setUTCFullYear(2020, 10, 0o5), 'yyyy-MM-dd');
  }

  openAttachmentModal(sourceId: string, sourceName: string, onlyPath?: boolean, path?: string, fileTitle?: string) {

    const base64 = onlyPath ? this.getFileDataWithPath(path) : this.getFileDataWithSourceIdAndSourceName(sourceId, sourceName);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = '85%';
    dialogConfig.disableClose = true;
    dialogConfig.data = { base64, fileTitle, showCoverPhoto: false };
    // this.dialog.open("", dialogConfig);
  }

  getFileDataWithPath(path: string): Observable<any> {
    return of(null);
  }

  getFileDataWithSourceIdAndSourceName(sourceId: string, sourceName: string, returnedTypeString = true): Observable<any> {
    return of(null);
  }

  dateRangeFormat(startDate, endDate, format) {
    return new DatePipe('en-Gb').transform(startDate, format) +
      ' to ' + new DatePipe('en-Gb').transform(endDate, format);
  }

  formatDate(date, format: string = 'dd/MM/yyyy'): string {
    return this.datePipe.transform(date, format);
  }

  formatDateTime(date: Date, format: string = 'yyyy-MM-dd\'T\'HH:mm:ss'): string {
    return this.datePipe.transform(date, format);
  }

  formatDateByDash(date: Date, format: string = 'yyyy-MM-dd'): string {
    return this.datePipe.transform(date, format);
  }

  loadTranslation(){
  }

  isAllBillPaid(customBills: any[]): boolean {
    let res = true;
    customBills?.forEach( (customBill) => {
      if (customBill?.status === 'UnPaid'){
        res = false;
      }
    });
    return res;
  }

  base64toBlob(base64Data: string, contentType: string): Blob {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  downloadBlobFile(blobData: any, filename: string){
    const url = URL.createObjectURL(blobData);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  getTableObjectValue(object: any, keyword: string) {
    const keyArray = keyword.split('.');
    let value = object;

    if (keyArray?.length > 0) {
      keyArray?.forEach( (key) => {
        if (value != null){
          if (Object?.keys(value)?.findIndex( k => k === key) > -1){
            value = value[key];
          } else {
            return null;
          }
        }
      });
    }
    return value;
  }

  getTableColumnKeywords(cacheTableColumns: TableColumn[]) {
    return cacheTableColumns?.sort( (a, b) => a?.id - b?.id)?.map( d => d?.keyword);
  }

  getSliderImages(){
    return [
      '/assets/images/bg/1.webp',
      '/assets/images/bg/2.webp',
      '/assets/images/bg/3.webp',
      '/assets/images/bg/4.webp',
      '/assets/images/bg/5.webp',
      '/assets/images/bg/6.webp'
    ];
  }

  async viewFile(base64string, fileFormat, name = null) {
    // const dialogRef = this.dialog.open("", {
    //   width: '80%',
    //   data: {
    //     file: base64string,
    //     format: fileFormat,
    //     name,
    //   },
    // });

    // return dialogRef.afterClosed().toPromise();
  }





  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}

